import React from "react";
import { Button, Modal } from "../../../../components";

const QbModal = ({ open, onClose, invoiceNumber }) => {
  return (
    <Modal isOpen={open} onClose={onClose} title="ALERT" width="max-w-2xl">
      <div className=" flex flex-col items-center justify-center gap-4">
        <p>Invoice #{invoiceNumber} successfully updated to Quick Books.</p>
        <div className="flex justify-end gap-3 mt-6">
          <Button title={"Close"} onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default QbModal;
